import { render, staticRenderFns } from "./messages-table.vue?vue&type=template&id=78f9e377&scoped=true"
import script from "./messages-table.vue?vue&type=script&lang=js"
export * from "./messages-table.vue?vue&type=script&lang=js"
import style0 from "./messages-table.vue?vue&type=style&index=0&id=78f9e377&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f9e377",
  null
  
)

export default component.exports